import React from "react";
import { Link } from "react-router-dom";
import ReactHtmlParser from "react-html-parser";

export default function SinglePost(props) {
  const { blog } = props;

  return (
    <div className="masonry-item col-lg-4 col-md-6 col-sm-12">
      <div className="blog-post twm-blog-post-1-outer">
        <div className="text-center">
          <div className="wt-post-media">
            <Link to={`/blog/${blog.id}`}>
              <img src={blog.image} alt={blog.title} />
            </Link>
          </div>
        </div>
        <div className="wt-post-info">
          <div className="wt-post-meta ">
            <ul>
              <li className="post-date">{blog.created_at}</li>
              <li className="post-author">
                By <a href="javascript::void(0);">{blog.author}</a>
              </li>
            </ul>
          </div>
          <div className="wt-post-title ">
            <h4 className="post-title">
              <Link to={`/blog/${blog.id}`}>{blog.title}</Link>
            </h4>
          </div>
          <div className="wt-post-text ">
            {/* <p>
              New chip traps clusters of migrating tumor cells asperiortenetur,
              blanditiis odit.
            </p> */}
            {ReactHtmlParser(blog.description)}
            {/* {blog.description} */}
          </div>
          <div className="wt-post-readmore ">
            <Link
              to={`/blog/${blog.id}`}
              className="site-button-link site-text-primary"
            >
              Read More
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
